import React from 'react';
import { Table, Button, Space, Tag } from 'antd';
import { PlusOutlined, EditOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import { NubGroupDTO } from '../types';

interface GroupListProps {
    groups: NubGroupDTO[];
    onGroupAction: (group: NubGroupDTO | null, action: 'view' | 'add' | 'edit' | 'delete') => void;
}

export const GroupList: React.FC<GroupListProps> = ({
                                                        groups,
                                                        onGroupAction
                                                    }) => {
    const columns = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            width: '15%',
            // @ts-ignore
            sorter: (a: NubGroupDTO, b: NubGroupDTO) => a.code.localeCompare(b.code)
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '20%',
            // @ts-ignore
            sorter: (a: NubGroupDTO, b: NubGroupDTO) => a.name.localeCompare(b.name)
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            width: '25%',
            render: (description: string) => description || '-'
        },
        {
            title: 'Primary',
            key: 'primary',
            width: '10%',
            render: (_: any, record: NubGroupDTO) => (
                <Tag color={record.primary ? 'blue' : 'default'}>
                    {record.primary ? 'Yes' : 'No'}
                </Tag>
            ),
            filters: [
                { text: 'Primary', value: true },
                { text: 'Secondary', value: false }
            ],
            onFilter: (value: boolean | string | number, record: NubGroupDTO) => record.primary === value
        },
        {
            title: 'Access Levels',
            key: 'accessLevels',
            width: '15%',
            render: (_: any, record: NubGroupDTO) => (
                <Space size={[0, 4]} wrap>
                    {record.accessLevels?.slice(0, 3).map((level) => (
                        <Tag key={level.code} color="green">
                            {level.name}
                        </Tag>
                    ))}
                    {record.accessLevels && record.accessLevels.length > 3 && (
                        <Tag color="default">+{record.accessLevels.length - 3} more</Tag>
                    )}
                </Space>
            )
        },
        {
            title: 'Actions',
            key: 'actions',
            width: '15%',
            render: (_: any, record: NubGroupDTO) => (
                <Space>
                    <Button
                        type="text"
                        icon={<EyeOutlined />}
                        title="View Group"
                        onClick={() => onGroupAction(record, 'view')}
                    />
                    <Button
                        type="text"
                        icon={<EditOutlined />}
                        title="Edit Group"
                        onClick={() => onGroupAction(record, 'edit')}
                    />
                    {!record.primary && (
                        <Button
                            type="text"
                            danger
                            icon={<DeleteOutlined />}
                            title="Delete Group"
                            onClick={() => onGroupAction(record, 'delete')}
                        />
                    )}
                </Space>
            )
        }
    ];

    return (
        <div>
            <div className="mb-4 flex justify-end">
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => onGroupAction(null, 'add')}
                >
                    Add User Group
                </Button>
            </div>

            <Table
                // @ts-ignore
                columns={columns}
                dataSource={groups}
                rowKey="code"
                pagination={{
                    showSizeChanger: true,
                    showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${total} groups`,
                    defaultPageSize: 10,
                    pageSizeOptions: ['10', '20', '50']
                }}
                scroll={{ x: 1000 }}
            />
        </div>
    );
};